import { XopowoStatsDisplay } from "../Xopowo/XopowoStatsDisplay.js"

export const MPTSoundIdentifierPanel = props => {
  const showXopowoStats = (props.usedStats !== undefined && props.showXopowo !== undefined && props.showXopowo === true)
  const imgSrc = props.imgSrc
  
  return (
    <div className="soundIdentifierPanel">
      <img src={imgSrc} alt="soundIdentifierPanel" id="soundIdentifierPanel" className="noContextMenu" />
      {showXopowoStats && <XopowoStatsDisplay usedStats={props.usedStats} show={props.showXopowo} />}
    </div>
  )
}